// Общие утилиты для матриц «позиции × даты» на страницах планов продаж
// (SalesPlanView.jsx и SalesPlanCreate.jsx).

const nf = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });

export const fmtInt = (n) => nf.format(Math.round(Number(n) || 0));
export const fmtMoney = (n) => `${nf.format(Math.round(Number(n) || 0))} ₽`;

// Метрики ячейки: одно число на ячейку.
// money=true — денежная метрика, видна только при праве на финансы.
export const PLAN_METRICS = [
  { key: 'qty', label: 'Штуки', money: false },
  { key: 'revenue', label: 'Сумма', money: true },
  { key: 'profit', label: 'Профит', money: true },
];

// Доступные метрики с учётом права на финансы.
export function availableMetrics(canFinance) {
  return canFinance ? PLAN_METRICS : PLAN_METRICS.filter((m) => !m.money);
}

export function isMoneyMetric(metricKey) {
  return PLAN_METRICS.find((m) => m.key === metricKey)?.money === true;
}

export function fmtMetric(value, metricKey) {
  return isMoneyMetric(metricKey) ? fmtMoney(value) : fmtInt(value);
}

// Определение права на финансы: предпочтительно флаг API (can_finance),
// с фолбэком на права пользователя из стора.
export function resolveCanFinance(apiCanFinance, user) {
  if (apiCanFinance === true || apiCanFinance === false) return apiCanFinance;
  if (!user) return false;
  return user.role === 'admin' || user.permissions?.salesPlansFinance === true;
}

// Значение метрики из series-объекта { byDate, total } за конкретный бакет даты.
export function seriesAt(series, dateKey, metricKey) {
  return Number(series?.byDate?.[dateKey]?.[metricKey]) || 0;
}

// Итог метрики из series-объекта.
export function seriesTotal(series, metricKey) {
  return Number(series?.total?.[metricKey]) || 0;
}

// Распределение локально посчитанного итога по бакетам дат, сохраняя форму
// серверного распределения (series.byDate). Если форма пустая — равномерно.
// Используется на странице создания, где итог прогноза пересчитывается на лету
// по % роста, а форма (вес каждого бакета по дням) берётся из ответа preview.
export function distributeByShape(localTotal, shapeSeries, dates, metricKey) {
  const out = {};
  const total = Number(localTotal) || 0;
  let shapeSum = 0;
  for (const d of dates) shapeSum += seriesAt(shapeSeries, d.key, metricKey);
  if (shapeSum > 0) {
    for (const d of dates) {
      out[d.key] = (seriesAt(shapeSeries, d.key, metricKey) / shapeSum) * total;
    }
  } else if (dates.length > 0) {
    const per = total / dates.length;
    for (const d of dates) out[d.key] = per;
  }
  return out;
}
